<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>

      <div class="main-div" v-loading.fullscreen.lock="fullscreenLoading">
        <el-container class="main-div parentDiv">
          <splitpanes class="default-theme defaultStyle custom-splite">
            <pane size="100" class="SideBarLeft">
              <!--SID1023 Body Part -->
              <template>
                <el-container style="height: 100%">
                  <div class="SID1023__searchRegist">
                    <!-- Breadcrumb section -->
                    <section>
                      <el-breadcrumb
                        separator-class="el-icon-arrow-right"
                        class="searchRegistDirection"
                      >
                        <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '' }">記事メンテナンス</el-breadcrumb-item>
                        <!-- <el-breadcrumb-item :to="{ path: '' }">記事メンテナンス</el-breadcrumb-item> -->
                      </el-breadcrumb>
                    </section>
                    <!-- Form1 section -->
                    <section class="Form1023">
                      <el-form ref="forminline" :model="forminline" :rules="rules1" label-width="auto">
                        <el-form-item class prop="medium" label="媒体">
                          <el-select v-model="forminline.medium" class @change="changetable($event)" placeholder="">
                            <el-option
                              v-for="item in getmediumoptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                        <section class="Form21023">
                          <!-- <el-form
                            :inline="true"
                            ref="forminline"
                            :model="forminline"
                            :rules="rules2"
                            class="demo-form-inline"
                            label-width="auto"
                          > -->
                            <el-row :gutter="15" class="formSectionTop">
                              <el-col :span="4" class="nthChildTwo" >
                                <div class="themelabel">キーワード</div> 
                                <el-form-item class prop="firstInput" >
                                <el-input v-model="forminline.firstInput" placeholder="キーワード" :disabled="articleMedia == 1"></el-input>
                                </el-form-item>
                                <div class="grid-content bg-purple"></div>
                              </el-col>
                              <el-col :span="4" class="nthChildInput">
                                 <div class="themelabel">媒体名</div> 
                                <el-form-item class prop="secondInput" >
                                <el-input v-model="forminline.secondInput" placeholder="媒体名" :disabled="articleMedia == 1"></el-input>
                                </el-form-item>
                                <div class="grid-content bg-purple"></div>
                              </el-col>
                              <el-col :span="4" class="nthChildThree">
                                <div class="themelabel">検索条件</div>
                                <el-select
                                  v-model="forminline.search"
                                  class="selectFormSearchCondition"
                                  @change="searchConditionChange($event)"
                                >
                                  <el-option
                                    v-for="item in getsearchcondition"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  ></el-option>
                                </el-select>
                                <div class="grid-content bg-purple"></div>
                              </el-col>
                              <el-col :span="5" class="nthChildFour">
                                <el-form class="ArticleSearchInner">
                                  <span class="themeAlertClass">{{ templateSpan }}</span>
                                  <div class="clippinglabel">クリッピング日</div>
                                  <el-form-item label="" class="ArticleSearchInnerItem1" prop="range">
                                    <!-- Change by CK for backlog Id: 1440 for calendar input  only by clicking  -->
                                    <v-date-picker
                                    class="select-margintop"
                                    mode='range'
                                    :masks="{ title: 'YYYY年MMM' }"
                                    v-model='forminline.range'
                                    :input-props='{readonly : true}'
                                    locale="ja"
                                    show-caps
                                    :popover="{  visibility: 'click' }" 
                                    @input="datePickerOnchange()">
                                    <input slot-scope="{ inputProps, inputEvents }"          
                                      v-bind="inputProps"
                                      v-on="inputEvents" />
                                    </v-date-picker>  
                                    </el-form-item>
                                </el-form>
                              </el-col>
                              
                              <el-col :span="4" class="nthChildFive">
                                <div class="themelabel">テーマ</div>
                                <el-select
                                  v-model="forminline.themeVmodel"
                                  class="selectFormSearchCondition"
                                  @change="themeChange($event)"
                                >
                                  <el-option
                                    v-for="item in gettheme"
                                    :key="item.id"
                                    :label="item.value"
                                    :value="item.value"
                                  ></el-option>
                                </el-select>
                                <div class="grid-content bg-purple"></div>
                              </el-col>
                              <el-col :span="3" class="nthChildSix">
                                <el-button  type="primary" @click="CheckForSelectionInTable('forminline')" plain>検索</el-button>
                                <div class="grid-content bg-purple"></div>
                              </el-col>
                            </el-row>
                          <!-- </el-form> -->
                        </section>
                      </el-form>
                    </section>
                    <!-- Form2 section -->
                   
                    <!-- Form3 section -->
                    <section class="Form1023">
                      <el-form ref="formThird" :model="formThird" label-width="auto">
                        <el-form-item>
                          <el-dropdown
                            split-button
                            type="primary"
                            @command="handleCommand"
                            trigger="click"
                          >
                            一括操作
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item
                                :command="option.option"
                                v-for="option in getBatchFor"
                                :key="option.id"
                              >{{ option.option }}</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </el-form-item>
                      </el-form>
                    </section>
                    <!-- Tale section -->
                    <section class="tableSection" v-show="isShowing_table1">
		                <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                      <el-table
                        v-loading="loading"
                        border
                        ref="multipleTable"
                        :data="getTableResult1023"
                        style="width: 100%"
                        class="colorChange"
                        @selection-change="handleSelectionChange"
                        :span-method="arraySpanMethod"
                        :row-class-name="tableRowClassName"
                        :cell-class-name="tableCellClassName"
                      >
		                  <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                        <el-table-column
                          type="selection"
                          class="messageCheckbox"
                          v-model="Selected"
                          width="60"
                        ></el-table-column>
                        <el-table-column property="no" fixed label="No." width="50" class="warning-row">
                          <template slot-scope="scope" >
                            <span v-if="scope.row.theme_name == 'Comment'" class="commentIcon" ></span>
                            {{scope.row.no}}
                          </template>
                        </el-table-column>
                        <el-table-column label="コメント" fixed width="100">
                          <template slot-scope="scope">
                            <el-button @click.native.prevent="handleEditRow(scope.$index, getTableResult1023)" type="primary" plain>編集</el-button>
                          </template>
                        </el-table-column>
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                        <el-table-column property="title" label="見出し" min-width="350">
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                          <template slot-scope="scope">
                            <div v-if="scope.row.no != '' && scope.row.no != null">
                            <div v-if="scope.row.data_section == 1">
                              <span v-if="mc_pdf_view_flag == false || scope.row.no_image_flag == true" class="ArticleTitleFor1023">{{scope.row.article_title}}</span>
                            <el-link
                              v-else-if="scope.row.no == ''"
                              :underline="false"
                              type="primary"
                              v-html="scope.row.article_title"
                              class="UserComment nonurl"
                            ></el-link>
                            <el-link
                            v-else
                              :underline="false"
                              type="primary"
                              v-html="scope.row.article_title"
                              @click="sendToErrorDisplay(scope.row.article_id,scope.row.data_section)"
                              class="UserComment"
                            ></el-link>
                            </div>
                            <div v-if="scope.row.data_section == 2">
                              <span v-if="sc_pdf_view_flag == false || scope.row.no_image_flag == true" class="ArticleTitleFor1023">{{scope.row.article_title}}</span>
                           <el-link
                              v-else-if="scope.row.no == ''"
                              :underline="false"
                              type="primary"
                              v-html="scope.row.article_title"
                              class="UserComment nonurl"
                            ></el-link>
                            <el-link
                            v-else
                              :underline="false"
                              type="primary"
                              v-html="scope.row.article_title"
                              @click="sendToErrorDisplay(scope.row.article_id,scope.row.data_section)"
                              class="UserComment"
                            ></el-link>
                            </div>
                            </div>
                              <div v-else>
                                <el-link
                                  :underline="false"
                                  type="primary"
                                  v-html="scope.row.article_title"
                                  class="UserComment nonurl"
                                ></el-link>
                              </div>
                          </template>
                        </el-table-column>
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                        <!-- 2023/09/22  #14935 START-->
                        <!-- <el-table-column property="media_name" width="120" label="媒体名">-->
                        <el-table-column property="media_name" min-width="170" label="媒体名">
                          <!-- 2023/09/22  #14935 END-->
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                          <template slot-scope="scope">
                            <span style v-if="scope.row.data_section == 1">
                              {{ scope.row.media_name }}
                              <br />
                              <img
                                class="tableInside-img"
                                src="../../assets/image/logo-new.png"
                                alt="LOGO"
                              />
                            </span>
                            <span style v-else-if="scope.row.data_section == 2">
                              {{ scope.row.media_name }}
                              <br />
                              <img
                                class="tableInside-img"
                                src="../../assets/image/Nikkie-logo-web.svg"
                                alt="LOGO"
                              />
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column property="issue_date" label="年月日" width="100"></el-table-column>
                        <el-table-column property="search_word" label="検索語"></el-table-column>
                        <!-- 2023/09/22  #14935 START-->
                        <!-- <el-table-column property="issue_type" label="その他書誌情報" width="83"></el-table-column>-->
                        <el-table-column property="issue_type" label="その他書誌情報" min-width="83"></el-table-column>
                        <!-- 2023/09/22  #14935 END-->
                        <el-table-column property="theme_name" label="テーマ名"></el-table-column>
                        <el-table-column width="160">
                          <div class="article-right" slot-scope="scope" >
                            <ul v-if="scope.row.data_section == 1"> 
                              <li v-if="mc_pdf_view_flag == true && scope.row.no_image_flag == false" >
                                <el-tooltip placement="top-start" effect="dark">
                                  <!-- 2021/02/23 #10026 START-->
                                  <!--<el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content">-->
                                  <el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content" :arrow="scope.row.image_info.length==1?'never':'hover'">
                                  <!-- 2021/02/23 #10026 END-->
                                    <el-carousel-item :setActiveItem="item" v-for="item in scope.row.image_info" :key="item">
                                      <div style="width: 100px; height: 150px">
                                        <img :src="item" alt="ArticleSnap" @error="replaceByDefault" class="sliderImage" />
                                      </div>
                                    </el-carousel-item>
                                  </el-carousel>
                                  <div class="custom-arrow"></div>
                                  <div @click="sendToErrorDisplay(scope.row.article_id,scope.row.data_section)" class="ico_pdf_upSmall AllNewsico_pdf_upSmall" tabindex="0"></div>
                                </el-tooltip>
                              </li>
                              <li v-else>
                                <div class="ico_pdf_Disable" tabindex="0"></div>
                              </li>
                              <li>
                                <div  @click="goToThumbnailDisplayScreen(scope.row.article_id,scope.row.data_section,scope.row.no)" class="ico_csv-output_upSmall" tabindex="0"></div>
                              </li>
                              <li v-if="mc_text_view_flag == true && scope.row.no_text_flag == false">
                                <div class="ico_text_upSmall" @click="getPdfPrintScreen(scope.row.data_section,scope.row.article_id)" tabindex="0"></div>
                              </li>
                              <li v-else>
                                <div class="ico_text_Disable" tabindex="0"></div>
                              </li>
                              <li v-if="mc_pdf_print_flag == true && scope.row.no_image_flag == false">
                                <div class="ico_print_upSmall AllNewsico_print_upSmall" @click="pdfPrint(scope.row.article_id,scope.row.data_section)" tabindex="0"></div>
                              </li>
                              <li v-else>
                                <div class="ico_print_Disable" tabindex="0"></div>
                              </li>
                            </ul>
                            <ul  v-else-if="scope.row.data_section == 2"> 
                              <li v-if="sc_pdf_view_flag == true && scope.row.no_image_flag == false" >
                                <el-tooltip placement="top-start" effect="dark">
                                  <!-- 2021/02/23 #10026 START-->
                                  <!--<el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content">-->
                                  <el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content" :arrow="scope.row.image_info.length==1?'never':'hover'">
                                    <!-- 2021/02/23 #10026 END-->
                                    <el-carousel-item :setActiveItem="item" v-for="item in scope.row.image_info" :key="item">
                                      <div style="width: 100px; height: 150px">
                                        <img :src="item" alt="ArticleSnap" @error="replaceByDefault" class="sliderImage" />
                                      </div>
                                    </el-carousel-item>
                                  </el-carousel>
                                  <div class="custom-arrow"></div>
                                  <div @click="sendToErrorDisplay(scope.row.article_id,scope.row.data_section)" class="ico_pdf_upSmall AllNewsico_pdf_upSmall" tabindex="0"></div>
                                </el-tooltip>
                              </li>
                              <li v-else>
                                <div class="ico_pdf_Disable" tabindex="0"></div>
                              </li>
                              <li>
                                <div  class="ico_csv-output_upSmall_disable" tabindex="0"></div>
                              </li>
                              <li v-if="sc_text_view_flag == true && scope.row.no_text_flag == false">
                                <div class="ico_text_upSmall" @click="goToThumbnailDisplayScreen(scope.row.article_id,scope.row.data_section,scope.row.no)" tabindex="0"></div>
                              </li>
                              <li v-else>
                                <div class="ico_text_Disable" tabindex="0"></div>
                              </li>
                              <li v-if="sc_pdf_print_flag == true && scope.row.no_image_flag == false">
                                <div @click="pdfPrint(scope.row.article_id,scope.row.data_section)"  class="ico_print_upSmall AllNewsico_print_upSmall"  tabindex="0"></div>
                              </li>
                              <li v-else>
                                <div class="ico_print_Disable" tabindex="0"></div>
                              </li>
                            </ul>
                          </div>
                        </el-table-column>
                        <el-table-column  label="公開" width="70" prop="disp_status">
                          <template slot-scope="scope">
                            <el-switch @change="updateReleaseflag($event,scope.row.data_section,scope.row.article_id)" v-model="scope.row.active"></el-switch>
                          </template>
                        </el-table-column>
                      </el-table>
                    </section>
                     <section class="tableSection" v-show="isShowing_table5">
                      <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
		      <el-table
                        v-loading="loading"
                        border
                        ref="multipleTable"
                        :data="getMagazineTableResult1023"
                        style="width: 100%"
                        class
                        @selection-change="handleSelectionChange"
                        :span-method="arrayMagazine"
                        :row-class-name="tableRowClassName"
                        :cell-class-name="tableCellClassName"
                      >
		      <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                        <el-table-column
                          type="selection"
                          class="messageCheckbox"
                          v-model="Selected"
                          width="60"
                        ></el-table-column>
                        <el-table-column property="no" label="No." fixed width="50">
                          <template slot-scope="scope">
                            <span class="commentIcon" v-if="scope.row.theme_name == 'Comment'"></span>
                            {{scope.row.no}}
                          </template>
                        </el-table-column>
                        <el-table-column label="コメント" fixed width="100">
                          <template slot-scope="scope">
                            <el-button @click.native.prevent="handleEditRow(scope.$index, getMagazineTableResult1023)" type="primary" plain>編集</el-button>
                          </template>
                        </el-table-column>
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                        <el-table-column property="title" label="見出し" min-width="350" class="magazinearticletitle">
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                          <template slot-scope="scope" >
                            <el-link
                                v-if="scope.row.no == ''"
                                :underline="false"
                                type="primary"
                                v-html="scope.row.article_title"
                                class="UserComment nonurl"
                            ></el-link>
                            <el-link v-else-if="scope.row.sales_datetime_flag == true"
                              :underline="false"
                              type="primary"
                              v-html="scope.row.article_title"
                              @click="$gotoEpub(scope.row.contents_id,scope.row.start_page,scope.row.sales_to_datetime)"
                            ></el-link>
                            <div v-else-if="scope.row.sales_datetime_flag == false"  v-html="scope.row.article_title">
                            </div>
                           </template>
                        </el-table-column>
                        <!-- 2023/09/22  #14935 START-->
                        <el-table-column min-width="170" property="media_name" label="媒体名"></el-table-column>
                        <!-- 2023/09/22  #14935 END-->
                        <!-- 2023/11/21  #14935 START-->
                        <el-table-column property="cover_date" label="号" width="135"></el-table-column>
                        <el-table-column property="page" label="ページ" min-width="75"></el-table-column>
                        <el-table-column property="category" label="雑誌カテゴリ" min-width="120"></el-table-column>
                        <el-table-column property="sales_datetime" label="提供期間" min-width="115"></el-table-column>
                        <!-- 2023/11/21  #14935 END-->
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                        <el-table-column property="search_word" label="検索語"></el-table-column>
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                        <el-table-column property="theme_name" label="テーマ名"></el-table-column>
                        <el-table-column  label="公開" width="70" property="disp_status">
                          <template slot-scope="scope">
                          <el-switch @change="updateReleaseflag($event,scope.row.data_section,scope.row.article_id)" v-model="scope.row.active"></el-switch>
                         </template>
                        </el-table-column>
                      </el-table>
                    </section>
                    <section class="tableSection" v-show="isShowing_table2">
		      <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                      <el-table
                        v-loading="loading"
                        border
                        ref="multipleTable"
                        :data="getWebTableResult1023"
                        style="width: 100%"
                        class
                        @selection-change="handleSelectionChange"
                        :span-method="arrayMethod"
                        :row-class-name="tableRowClassName"
                        :cell-class-name="tableCellClassName"
                      >
		      <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                        <el-table-column
                          type="selection"
                          class="messageCheckbox"
                          v-model="Selected"
                          width="60"
                        ></el-table-column>
                        <el-table-column property="no" label="No." fixed width="50">
                          <template slot-scope="scope">
                            <span class="commentIcon" v-if="scope.row.theme_name == 'Comment'"></span>
                            {{scope.row.no}}
                          </template>
                        </el-table-column>
                        <el-table-column label="コメント" fixed width="100">
                          <template slot-scope="scope">
                            <el-button @click.native.prevent="handleEditRow(scope.$index, getWebTableResult1023)" type="primary" plain>編集</el-button>
                          </template>
                        </el-table-column>
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                        <el-table-column property="title"  label="見出し" min-width="350" class="webarticletitle">
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                          <template slot-scope="scope" >
                            <div v-if="scope.row.url != '' && scope.row.url != null">
                              <!-- <a :href="scope.row.url" target="_blank" class="webarticletitle"> -->
                                <el-link
                                  :underline="false"
                                  type="primary"
                                  v-html="scope.row.article_title"
                                  @click="articleSend(scope.row.article_id,scope.row.data_section,scope.row.url)"
                                  class="UserComment"
                                ></el-link>
                              <!-- </a> -->
                            </div>
                            <div v-else>
                              <el-link
                                :underline="false"
                                type="primary"
                                v-html="scope.row.article_title"
                                class="UserComment nonurl"
                              ></el-link>
                            </div>
                          </template>
                        </el-table-column>
                        <!-- 2023/09/22  #14935 START-->
                        <el-table-column min-width="170" property="media_name" label="媒体名"></el-table-column>
                        <!-- 2023/09/22  #14935 END-->
                        <el-table-column property="reporting_date" label="年月日" width="100"></el-table-column>
                        <el-table-column property="media_type" label="媒体種別"></el-table-column>
                        <!-- 2023/09/22  #14935 START-->
                        <el-table-column property="category" label="サイトカテゴリー" min-width="83"></el-table-column>
                        <!-- 2023/09/22  #14935 END-->
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                        <el-table-column property="search_word" label="検索語"></el-table-column>
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                        <el-table-column property="theme_name" label="テーマ名"></el-table-column>
                        <el-table-column  label="公開" width="70" property="disp_status">
                          <template slot-scope="scope">
                          <el-switch @change="updateReleaseflag($event,scope.row.data_section,scope.row.article_id)" v-model="scope.row.active"></el-switch>
                         </template>
                        </el-table-column>
                      </el-table>
                    </section>
                    <section>
                      <!-- /*** Change by CK for backlog Id: 1626 */ -->
                      <el-dialog
                        title="コメント付与"
                        :visible.sync="centerDialogVisible"
                        show-close:false
                        
                        :close-on-click-modal="false"
                        :close-on-press-escape="false"
                      
                        @close='closeDialog'
                        center
                      >
                        <QuillEditor commentValues/>
                        <span slot="footer" class="dialog-footer">
                          <el-button type="info" @click="centerDialogVisible = false" plain>キャンセル</el-button>
                          <el-button
                            class="leftmargin"
                            type="primary"
                            @click="submitArticleComment"
                            plain
                          >保存</el-button>
                        </span>
                      </el-dialog>
                    </section>
                  </div>
                </el-container>
              </template>
              <!--SID1023 Body Part End-->
            </pane>
            <pane class="SideBarRight">
              <SideBar class="SidePane" />
            </pane>
          </splitpanes>
        </el-container>
      </div>
      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import error_image from "../../assets/image/errorThumbnail@3_200x200.png";
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import QuillEditor from "../common/quill-editor.vue";
import { mapGetters } from "vuex";
import Vue from "vue";
import json from "../../components/config.json";
const newArr = {};
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import Common from '../../common/CommonFunc.js';

var CurrentYear = new Date().getFullYear();
var CurrentMonth = new Date().getMonth();
var CurrentDay = new Date().getDate();

export default {
  name: "app",
  components: {
    Header,
    SideBar,
    FooterComponent,
    Splitpanes,
    Pane,
    QuillEditor
  },
  data() {
    var checkdate = (rule, value, callback) => {
		var date_select = this.forminline.range.start;
		var todaydate=new Date();
		if (date_select > todaydate) {
			callback(new Error("集計期間は正しい日付を入力してください。"));
		} else {
			callback();
		}
		};
    
    return {
      releaseFlag: true,
      isShowing_table1: false,
      isShowing_table2: false,
      isShowing_table5: false,
      fullscreenLoading: false,
      loading : false,
      tableflag: '',
      mediavalue: '',
      articleMedia: '',
      select_search_value: '',
      select_theme_value: '',
      select_theme_id: '',
      loadTableComment: '',
      userId: '',
      contractId: '',
      theme_browsing: '',
      csvIcon: '0',
      Selected: '',
      commentValues: '',
      articleCommentId: '',
      articleDataSection: '',
      switchEnable: true,
      switchDisable: false,
      switchNeutral: false,
      templateSpan:'',
      form: {
        medium: '',

        Keyword: "キーワード",
        mediaName: "媒体名"
      },
      
      date: new Date(),
      rules1: {
            medium: [
                { required: true, message: '媒体名を選択してください', trigger: 'change' }
            ],
            firstInput:[
           
              { max: 500, message: "キーワードは500文字以下を入力してください。" },
            ],
            secondInput:[
                { max: 100, message: "媒体名は100文字以下を入力してください。" }
            ],
            range: [
              { required: true, message: '集計期間を指定してください。', trigger: 'blur'},
              { validator:checkdate,message:'集計期間は正しい日付を入力してください。', trigger: 'change'}
            ]
            
           
         },
        
      forminline: {
        medium: '',
        Keyword: "キーワード",
        mediaName: "媒体名",
        themeVmodel: "テーマを選択",
        firstInput:'',
        secondInput: "",
        search: "検索条件から選択",
        range: {
        start: new Date(CurrentYear, CurrentMonth, CurrentDay), // Jan 16th, 2018
        end: new Date(CurrentYear, CurrentMonth, CurrentDay) // Jan 19th, 2018
      }
      },
      formThird: {
        Batch: "一括操作"
      },
      value1: false,
      centerDialogVisible: false,
      multipleSelection: [],
      commentArray: [],
      setAddValue: '',
      mc_pdf_view_flag: '',
      mc_pdf_print_flag: '',
      mc_text_view_flag: '',
      mc_text_print_flag: '',
      sc_pdf_view_flag: '',
      sc_pdf_print_flag: '',
      sc_text_view_flag: '',
      sc_text_print_flag: '',
      contractCode:'',
      session_id: '',
    };
  },

  computed: {
    ...mapGetters("situation1023", [
      "getTableResult1023",
      "getcheck",
      "gettheme",
      "getBatchFor",
      "getsearchcondition",
      "getmediumoptions",
      "getcommentArray",
      "getarticleCommentIndexArray",
      "getArticleComment",
      "getMagazineTableResult1023",
      "getMagazineArrayComment",
      "getWebTableResult1023",
      "getWebArrayComment",
      "setmediumoptions"
    ]),
    // 2024/05/14  #13819  START
    ...mapGetters("situation0003",["getStatus","getErrorMessage","getMessageCode"]),
    // 2024/05/14  #13819  END
    ...mapGetters("situation0001", [
        "getUserId",
        "getContractId",
        "getThemeBrowsing",
        "getContractCode",
        "getCompanyConfigurationInfo",
        "getMC_Pdf_View_Flag",
        "getMC_Pdf_Print_Flag",
        "getMC_Text_View_Flag",
        "getMC_Text_Print_Flag",
        "getSC_Pdf_View_Flag",
        "getSC_Pdf_Print_Flag",
        "getSC_Text_View_Flag",
        "getSC_Text_Print_Flag",
        "getServiceLinkageInfo",
        "getMessageInfo",
        "getOut_Demand_Confirm_Message_Div_Flag",
        "getDemandConfirmPdfMessage",
        "getDemandConfirmTextMessage",
        "getDemandConfirmPrintMessage",
        "getUserGroupName",
      ]),
       ...mapGetters("situation0001", [
        "getContractCode"
      ])
  },
  methods: {

    replaceByDefault(event) {
     
      event.target.src = error_image;
    },
    
    //For individual switch updation
    updateReleaseflag($event,datasection,articleid){
      this.$LogButtonEvent("1023","ToggleClick");
      this.$LogMethodIN("1023","updateReleaseflag");
      var status;
      if($event == true){
        status = 0
      }else{
        status = 3
      }
      //2024/02/15  #17449  START
      this.fullscreenLoading = true;
      //2024/02/15  #17449  END
      var articlePublish_switch = {
                        article_info:[
                                        { 
                                        data_section:datasection,
                                        article_id:articleid,
                                        }],
        
                        disp_status:status,
                        contract_code:this.contractCode
                    };
                    //Api call for publish individual article
                    //2024/02/15  #17449  START
                    this.$store.dispatch('communication1023/toggleStatus_individual', articlePublish_switch).then(()=>{
                    this.fullscreenLoading = false;
                    });
                    //2024/02/15  #17449  END
                    this.$LogMethodOut("1023","updateReleaseflag");
    },
    //Display the Error msg for PDf
    sendToErrorDisplay(articleid,data_section){
      this.$LogButtonEvent("1023","Showpdf");
      this.$LogMethodIN("1023","sendToErrorDisplay");
      var pdfValues = {
        pdf_flag: 1,
        article_info:[
          {
            article_id: articleid,
            data_section: data_section
          }
        ],
        user_id:this.userId,
        contract_code:this.contractCode,
        theme_browsing: this.theme_browsing,
        display_id:"SID1024",
        is_mail:false
      };
      var inputPDFCountData = {
        data_info:[{
          data_section: data_section,
          user_id:this.userId,
          request_div:1,
          article_id:articleid,
          session_id: this.session_id, 
          user_group_name:this.user_group_name
        }]
      };

      var printCombinedArray = [];

      printCombinedArray = [...printCombinedArray, pdfValues, inputPDFCountData];

      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPdfMessage,"確認",
        {
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
          beforeClose: (action, instance, done) => {
            if(action === "confirm"){
              /*******BT08460_EXTERNAL-1539 issue fix*******/
              this.$session.set('pdfCombinedArray', printCombinedArray);
              let routeData = this.$router.resolve({name: '0001-001'}); 
              window.open(routeData.href, '_blank');
              /*this.fullscreenLoading = true;
              this.$store.dispatch('communication0004/getPdfDisplay', printCombinedArray).then(() => {
                this.fullscreenLoading = false;
              })
              .catch(() => {
                this.fullscreenLoading = false;
              })*/
              /*******BT08460_EXTERNAL-1539 issue fix*******/
              done();
            }else{
              done();
            }
          }
        });
      }
      else
      {
        /*******BT08460_EXTERNAL-1539 issue fix*******/
        this.$session.set('pdfCombinedArray', printCombinedArray);
        let routeData = this.$router.resolve({name: '0001-001'}); 
        window.open(routeData.href, '_blank');
        /*this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfDisplay', printCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })*/
        /*******BT08460_EXTERNAL-1539 issue fix*******/
      }
      this.$LogMethodOut("1023","sendToErrorDisplay");
    },
    /*
    workedBy: BM  
    comment : For web article click 
     */
    articleSend(articleid,data_section,url){
      this.$LogButtonEvent("1023","newLink");
      this.$LogMethodIN("1023","articleSend");
      //alert(url)
       window.open(url, '_blank');
      
      this.$LogMethodOut("1023","articleSend");
    },
    getPdfPrintScreen(data_section,articlieid){
      this.$LogButtonEvent("1023","Showpdfprintscreen");
      this.$LogMethodIN("1023","getPdfPrintScreen");
      if(data_section == 1)
      {
        var articleDetails = {
          articleId: articlieid,
          data_section: data_section,        
          printOption: true,
          is_mail:false,
          display_id:"SID1024"
        };
        if(this.getOut_Demand_Confirm_Message_Div_Flag)
        {
          this.$confirm(this.getDemandConfirmTextMessage,"確認",
            {
              showCancelButton: true,
              confirmButtonText: "OK",
              cancelButtonText: "キャンセル",
              beforeClose: (action, instance, done) => {
                if(action === "confirm")
                {
                  let routeData = this.$router.resolve({name: '0008', query: articleDetails}); 
                  window.open(routeData.href, '_blank');
                  done();
                }
                else
                {
                  done();
                }
              }
            }
          );
        }
        else
        {
          let routeData = this.$router.resolve({name: '0008', query: articleDetails}); 
          window.open(routeData.href, '_blank');
        }
        
      }
      else
      {
        this.$session.set('Article_Id', articlieid);
        if(this.getOut_Demand_Confirm_Message_Div_Flag)
        {
          this.$confirm(this.getDemandConfirmTextMessage,"確認",
            {
              showCancelButton: true,
              confirmButtonText: "OK",
              cancelButtonText: "キャンセル",
              beforeClose: (action, instance, done) => {
                if(action === "confirm")
                {
                  let routeData = this.$router.resolve({name: '0007'}); 
                  window.open(routeData.href, '_blank');
                  done();
                }
                else
                {
                  done();
                }
              }
            }
          );
        }
        else
        {
          let routeData = this.$router.resolve({name: '0007'}); 
          window.open(routeData.href, '_blank');
        }
      }
      this.$LogMethodOut("1023","getPdfPrintScreen");
    },  
     
    pdfPrint(articleid,datasection){
      this.$LogButtonEvent("1023","PrintPdf");
      this.$LogMethodIN("1023","pdfPrint");
      var pdfValues = {
        pdf_flag:2,
        article_info:[
          {
            article_id: articleid,
            data_section: datasection
          }
        ],
        user_id:this.userId,
        contract_code:this.contract_code,
        theme_browsing:this.theme_browsing,
        display_id:"SID1024"
      }
      var inputPDFCountData = {
        data_info:[{
          data_section: datasection,
          request_div:2,
          read_count: 1,
          user_id:this.userId,
          article_id:articleid,
          session_id: this.session_id, 
          user_group_name:this.user_group_name
        }]
      };
      var printCombinedArray = [];
      printCombinedArray = [...printCombinedArray, pdfValues, inputPDFCountData];

      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPrintMessage,"確認",
        {
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
          beforeClose: (action, instance, done) => {
            if(action === "confirm")
            {
              this.fullscreenLoading = true;
              this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
                this.fullscreenLoading = false;
              })
              .catch(() => {
                this.fullscreenLoading = false;
              })
              done();
            }
            else
            {
              done();
            }
          }
        });
      }
      else
      {
        this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      this.$LogMethodOut("1023","pdfPrint");
    },
    goToThumbnailDisplayScreen(article_id,data_section,no){
      this.$LogButtonEvent("1023","DisplayCsv");
      this.$LogMethodIN("1023","goToThumbnailDisplayScreen");
      this.$session.set('Article_Id', article_id);
      this.$session.set('CurrentRowNo', no - 1);
      this.$session.set('CurrentSID', "1023");
      if(data_section == 1){
        let routeData = this.$router.resolve({name: '0006'}); 
        window.open(routeData.href, '_blank');
      }else if(data_section == 2){
        let routeData = this.$router.resolve({name: '0007'}); 
        window.open(routeData.href, '_blank');
      }
      this.$LogMethodOut("1023","goToThumbnailDisplayScreen");
    },

    tableRowClassName({row}) {
      if (row.active== true) { 
      //return 'success-row'; 
     
      } 
      else if (row.active == false) 
      { 
        
        this.active_el = 1;

        return 'warning-row'; 
      }
    },

    // 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START
    tableCellClassName({column}) {
      if (typeof(column.property) == "undefined") {
        return 'text-center'
      } else if (column.property == "disp_status") {
        return 'text-center'
      } else {
        return "text-start"
      }
    },
    // 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END
    
    //Functions for getting value selected in theme dropdown
    themeChange($event){
      this.$LogButtonEvent("1023","SelectTheme");
      this.$LogMethodIN("1023","themeChange");
			for(var j=0; j<this.gettheme.length;j++){
					if($event == this.gettheme[j].value){
            this.select_theme_value = this.gettheme[j]["value"];
            this.select_theme_id = this.gettheme[j]["id"];
					}
      }
     
      this.$LogMethodOut("1023","themeChange");
    },
    //Functions for getting value selected in search dropdown
    searchConditionChange($event){
      this.$LogButtonEvent("1023","Searchcondition");
      this.$LogMethodIN("1023","searchConditionChange");
      for(var j=0; j<this.getsearchcondition.length;j++){
					if($event == this.getsearchcondition[j].value){
            this.select_search_value = this.getsearchcondition[j]["value"];
            this.articleMedia = 1;
					}
      }
      //if search dropdown is selected, clear and disable the keyword and media textbox
			if(this.select_search_value == '検索条件から選択'){
        this.articleMedia = 0;
			}else{
        this.forminline.firstInput = '';
        this.forminline.secondInput = '';
      }
      this.$LogMethodOut("1023","searchConditionChange");
    },
    //Functions for getting value selected in Media dropdown
    changetable($event) {
      this.$LogButtonEvent("1023","MediumSelect");
      this.$LogMethodIN("1023","changetable");
     for(var j=0; j<this.getmediumoptions.length;j++){
				if($event == this.getmediumoptions[j].value){
               this.mediavalue = this.getmediumoptions[j]["value"];
				}
      }
      this.$LogMethodOut("1023","changetable");
    },
    //Functions for batch operation for article publish, private, add comment and delete comment
    handleCommand(command) {
      //if user select add comment
      this.$LogButtonEvent("1023","BatchOperation");
      this.$LogMethodIN("1023","handleCommand");
      if (command == "コメント付与") {
        this.setAddValue = '0';
        if (this.multipleSelection == "") {
          this.$confirm(
            json["1023_delete_confirm_message"],
            json["1023_delete_confirm_message_title"],
            {
              showCancelButton: false,
              confirmButtonText: "OK",
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  if (this.multipleSelection) {
                    var arrayLength = this.multipleSelection.length;
                    for (var i = 0; i < arrayLength; i++) {
                      this.multipleSelection[i].releaseFlag = true;
                    }
                  }
                  done();
                } else {
                  done();
                }
              }
            }
          );
        } else {
          this.$store.commit('situation1023/setArticleComment')
          this.centerDialogVisible = true;
        }
      }//if user select delete comment
      else if(command == "コメント削除"){
       
        if (this.multipleSelection == "") {
          this.$confirm(
            json["1023_delete_confirm_message"],
            json["1023_delete_confirm_message_title"],
            {
              showCancelButton: false,
              confirmButtonText: "OK",
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  if (this.multipleSelection) {
                    
                    var arrayLength = this.multipleSelection.length;
                    for (var i = 0; i < arrayLength; i++) {
                      this.multipleSelection[i].active = true;
                      
                    }
                  }
                  done();
                } else {
                  done();
                }
              }
            }
          );
        }
        else{
          this.$confirm(
            json["1023_4_delete_confirm_message"],
            json["1023_4_delete_confirm_message_title"],
            {
              showCancelButton: true,
              confirmButtonText: "OK",
              cancelButtonText: "キャンセル",
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                   var del_articleDetails = {
                        contract_id: this.contractId, 
                        article_info: [], 
                        /* 2021/01/29 #10501 START */
                        //comment:this.multipleSelection[0].comment,
                        comment:"DummyComment",
                        /* 2021/01/29 #10501 START */
                        edit_flg: 1
                    };
                  for(var i=0;i<this.multipleSelection.length;i++){
                    var delArray={};
                    delArray.data_section=this.multipleSelection[i].data_section;
                    delArray.article_id=this.multipleSelection[i].article_id;
                    //delArray.comment= this.multipleSelection[i].article_comment; 
                    del_articleDetails.article_info.push(delArray);
                      
                  }
                   //Api call for delete selected article
                   this.$store.dispatch('communication1023/updateArticleComment', del_articleDetails).then(() => {
                  
                    Vue.prototype.$session.set('InputParameterFor0006',this.loadTableComment);
                    Vue.prototype.$session.set('CurrentAID',"0071");
                  this.$store.dispatch('communication1023/getTableData', this.loadTableComment);
                  done();
                   });
                  

                } else {
                  done();
                }
              }
            }
          );
        }
      }//if user select publish comment
      else if (command == "公開") {
        if (this.multipleSelection == "") {
          this.$confirm(
            json["1023_delete_confirm_message"],
            json["1023_delete_confirm_message_title"],
            {
              showCancelButton: false,
              confirmButtonText: "OK",

              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  if (this.multipleSelection) {
                    var arrayLength = this.multipleSelection.length;
                    for (var i = 0; i < arrayLength; i++) {
                      this.multipleSelection[i].active = true;
                    }
                  }
                  done();
                } else {
                  done();
                }
              }
            }
          );
        } else {
          this.$confirm(
            json["1023_1_delete_confirm_message"],
            json["1023_1_delete_confirm_message_title"],
            {
              showCancelButton: true,
              confirmButtonText: "OK",
              cancelButtonText: "キャンセル",
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  if (this.multipleSelection) {
                    //2024/02/15  #17449  START
                    this.fullscreenLoading = true;
                    //2024/02/15  #17449  END
                    var arrayLength = this.multipleSelection.length;
                    var commentArray = [];
                    for (var i = 0; i < arrayLength; i++) {
                      var articleId = this.multipleSelection[i].article_id;
                      var dataSection = this.multipleSelection[i].data_section;
                      commentArray = [...commentArray, {data_section: dataSection, article_id: articleId}];
                      this.multipleSelection[i].active = true;
                    }
                    var articlePublish = {
                        "article_info": commentArray,
                        "disp_status": 0,
                        "contract_code": Vue.prototype.$session.get('contract_code')
                    };
                    //Api call for publish selected article
                    this.$store.dispatch('communication1023/toggleStatus', articlePublish).then(()=>{
                      //2024/02/15  #17449  START
                    this.fullscreenLoading = false;
                    //2024/02/15  #17449  END
                      this.ShowTable('forminline');

                    });
                  }
                  done();
                } else {
                  done();
                }
              }
            }
          );
        }
      }//if user select article not publish
      else if (command == "非公開") {
       
        if (this.multipleSelection == "") {
          this.$confirm(
            json["1023_delete_confirm_message"],
            json["1023_delete_confirm_message_title"],
            {
              showCancelButton: false,
              confirmButtonText: "OK",

              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  if (this.multipleSelection) {
                    var arrayLength = this.multipleSelection.length;
                    for (var i = 0; i < arrayLength; i++) {
                       
                      this.multipleSelection[i].active = true;
                    }
                  }
                  done();
                } else {
                  done();
                }
              }
            }
          );
        } else {
          this.$confirm(
            json["1023_2_delete_confirm_message"],
            json["1023_2_delete_confirm_message_title"],
            {
              showCancelButton: true,
              confirmButtonText: "OK",
              cancelButtonText: "キャンセル",
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  //if (this.multipleSelection) {
                    //2024/02/15  #17449  START
                    this.fullscreenLoading = true;
                    //2024/02/15  #17449  END
                    var arrayLength2 = this.multipleSelection;
                    var commentArrayPrivate = [];
                    var j;
                    for ( j = 0; j < arrayLength2.length; j++) {
                      //alert(this.multipleSelection[j].data_section)
                      var articleIdPrivate = arrayLength2[j].article_id;
                      var dataSectionPrivate = arrayLength2[j].data_section;
                      commentArrayPrivate = [...commentArrayPrivate, {data_section: dataSectionPrivate, article_id: articleIdPrivate}];
                      
                      this.multipleSelection[j].active = false;
                      
                      //document.querySelector(".el-table__row").style.background = "red";
                    }
                    var articlePrivate = {
                        "article_info": commentArrayPrivate,
                        "disp_status": 3,
                        "contract_code": Vue.prototype.$session.get('contract_code')
                    };
                    //Api call for switch article to non-publish
                    this.$store.dispatch('communication1023/toggleStatus', articlePrivate).then(()=>{
                      //2024/02/15  #17449  START
                      this.fullscreenLoading = false;
                      //2024/02/15  #17449  END
                      this.ShowTable('forminline');
                    });
                  //}
                  done();
                } else {
                  done();
                }
              }
            }
          );
        }
      }
      this.$LogMethodOut("1023","handleCommand");
    },
    //Method for merge the columns of comments for News Article
    arraySpanMethod({ rowIndex, columnIndex }) {
      // This will check the IndexArray of Comments to merge the columns of Comments
      if (this.getarticleCommentIndexArray.indexOf(rowIndex) > -1) {
        if (columnIndex === 1) {
          // no
          return [1, 3]; // This will take colspan = 2
        } else if (columnIndex === 3) {
          //HeaderText
          return [1, 8]; // This will take colspan = 5
        } else {
          return [0, 0];
        }
      }
    },
    //Method for merge the columns of comments for Magazine Article
    arrayMagazine({ rowIndex, columnIndex }) {
      // This will check the IndexArray of Comments to merge the columns of Comments
      if (this.getMagazineArrayComment.indexOf(rowIndex) > -1) {
        if (columnIndex === 1) {
          // no
          return [1, 3]; // This will take colspan = 2
        } else if (columnIndex === 3) {
          //HeaderText
          // 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START
          //return [1, 8]; // This will take colspan = 5
          return [1, 9];
          // 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END
        }else {
          return [0, 0];
         }
      }
    },
    //Method for merge the columns of comments for Web Article
    arrayMethod({ rowIndex, columnIndex }) {
      // This will check the IndexArray of Comments to merge the columns of Comments
      if (this.getWebArrayComment.indexOf(rowIndex) > -1) {
        if (columnIndex === 1) {
          // no
          return [1, 3]; // This will take colspan = 2
        } else if (columnIndex === 3) {
          //HeaderText
          // 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START
          //return [1, 7]; // This will take colspan = 5
          return [1, 8];
          // 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END
        } else {
          return [0, 0];
        }
      }
    },
    //Method for push checkbox selected article into an array
    handleSelectionChange(val) {
      this.$LogButtonEvent("1023","SelectionChange");
      this.$LogMethodIN("1023","handleSelectionChange");
      /* 2021/01/29 #10498 START */
      val=val.filter(val=>val.theme_name!='Comment')
      /* 2021/01/29 #10498 END */
      newArr.value=  val;
      this.multipleSelection = val;
      this.$LogMethodOut("1023","handleSelectionChange");
    },
    
    //Methods for add and update the comments for article into an Data Base
    submitArticleComment() {
     
      this.$LogButtonEvent("1023","SaveComment");
      this.$LogMethodIN("1023","submitArticleComment");
      
      var quillEditorContent = this.getArticleComment;
      // For gettig the comments Line
      quillEditorContent = quillEditorContent.trim();
      if (quillEditorContent != "") { 
        /*** Worked by AJ for backlog Id: 1651 */
        //code for remove HTML tags from the comment
        var quillEditorValue = quillEditorContent.replace( /(<([^>]+)>)/ig, '');
        var quillEditorLength = quillEditorValue.length;
        /*** Worked by AJ for backlog Id: 1651 */
        if (quillEditorLength <= 500) {
          this.centerDialogVisible = false;
          var articleDetails;
          //This is for the individual button click inside table
          if(this.setAddValue == '1'){
            articleDetails = {
                  contract_id: this.contractId, 
                  article_info: [
                    {
                      data_section: this.articleDataSection,
                      article_id: this.articleCommentId
                    }
                  ], 
                  comment: Common.Session.linkify(this.getArticleComment), 
                  edit_flg: 0
              };
          }
          else {
            //This is for the batch oeration quill 
            articleDetails = {
              contract_id: this.contractId, 
              article_info:[],
              comment: Common.Session.linkify(this.getArticleComment), 
              edit_flg: 0
            };
            for(var i=0;i<this.multipleSelection.length;i++)
            {
              var newArray={};
              
              newArray.data_section= this.multipleSelection[i].data_section;
              newArray.article_id=this.multipleSelection[i].article_id;
              articleDetails.article_info.push(newArray);
            }
            
            
          }
          //Api call for update comments for the article
          this.$store.dispatch('communication1023/updateArticleComment', articleDetails).then(() => {
            Vue.prototype.$session.set('InputParameterFor0006',this.loadTableComment);
            Vue.prototype.$session.set('CurrentAID',"0071");
            this.$store.dispatch('communication1023/getTableData', this.loadTableComment)
          })
        } else {
          this.$confirm(
            json["1023_quill_length_exceeded_message"],
            json["1023_quill_length_exceeded_title"],
            {
              showCancelButton: false,
              confirmButtonText: "OK",
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  done();
                } else {
                  done();
                }
              }
            }
          );
        }
      } else {
        this.$confirm(
          json["1023_quill_empty_message"],
          json["1023_quill_empty_title"],
          {
            showCancelButton: false,
            confirmButtonText: "OK",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                done();
              } else {
                done();
              }
            }
          }
        );
      }
      this.$LogMethodOut("1023","submitArticleComment");
    },
    formatter(row) {
      return row.address;
    },
    //Methods for open quill editor for edit the comments for the articles
    handleEditRow(index,rows) {
      this.$LogButtonEvent("1023","Edit");
      this.$LogMethodIN("1023","handleEditRow");
      this.setAddValue = '1';
      this.commentValues = rows[index].comment;
      this.articleCommentId = rows[index].article_id;
      this.articleDataSection = rows[index].data_section;
      //Get the index and table data
      //Get the table data of selected index
      //Set the check box selected array
      if(rows.length !== index+1){
        this.$store.commit('situation1023/setArticleComment')
        //If there exists already comment for an article
        //Get the comment and set it to article Comment
        if(rows[index+1].theme_name == 'Comment'){
          this.$store.commit('situation1023/setArticleComment',  rows[index+1].article_title )
        }
      }
      // 2021/01/29 #10493 START
      else{
        this.$store.commit('situation1023/setArticleComment')
      }
      // 2021/01/29 #10493 END
      this.centerDialogVisible = true;
      this.$LogMethodOut("1023","handleEditRow");
    },
    datePickerOnchange(){
      if(this.forminline.range == null || this.forminline.range == ''){
							this.templateSpan="期間選択は正しい日付を入力してください。";
            }else{
              this.templateSpan="";

            }
    },
    CheckForSelectionInTable(formName1){
          this.$refs[formName1].validate((valid) => {
          if(valid)
          {
          var selection = this.multipleSelection;
          if(selection.length > 0 ){
            this.$confirm("選択された記事を外し、検索してもよろしいでしょうか？","確認",
              {
                showCancelButton: true,
                confirmButtonText: "OK",
                cancelButtonText: "キャンセル",
                beforeClose: (action, instance, done) => {
                  if(action === "confirm")
                  {
                    this.multipleSelection="";
                    this.ShowTable();
                    done();
                  }
                  else
                  {
                    done();
                  }
                }
            });
          }else{         
            this.ShowTable();          
          }
          }
          })  
    },
    //Methods for displaying table data for News and Web articles
    ShowTable(){
     this.$LogButtonEvent("1023","Search");
     this.$LogMethodIN("1023","ShowTable");

     console.log(this.mediavalue)
            if(this.mediavalue == "WEB")
            {   //if media value is Web
                this.isShowing_table2= true;
                this.isShowing_table5= false;
                this.isShowing_table1= false;
               
             }
              else if(this.mediavalue == "雑誌")
              { //if media value is Magazine
                this.isShowing_table5= true;
                this.isShowing_table1= false;
                this.isShowing_table2= false;
               
              }
              else
              { //if media value is News
                this.isShowing_table1= true;
                this.isShowing_table5= false;
                this.isShowing_table2= false;
                
                
              }
            
            var mediaDropdownValue = this.mediavalue
            if(mediaDropdownValue == "WEB"){
              mediaDropdownValue = 2
            }else if(mediaDropdownValue == "雑誌"){
              mediaDropdownValue = 5
            }else{
              mediaDropdownValue = 1
            }
            
            var startDate = this.forminline.range.start;
            var sdate = new Date(startDate),
            smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
            sday = ("0" + sdate.getDate()).slice(-2);
            //convert the date format
            var startResult = [sdate.getFullYear(), smnth, sday].join("/");
            //get the end date from the selected date
            var endDate = this.forminline.range.end;
            var edate = new Date(endDate),
            emnth = ("0" + (edate.getMonth() + 1)).slice(-2),
            eday = ("0" + edate.getDate()).slice(-2);
            //convert the date format
            var endResult = [edate.getFullYear(), emnth, eday].join("/");
            var searchDetails;
            if(this.select_search_value == '検索条件から選択'){
              this.select_search_value = ''
            }
            if(this.select_search_value != '')
            {
              if(this.select_theme_value != '')
              {
                searchDetails = {
                  contract_id:this.contractId,
                  user_id:this.userId,
                  search_title:this.select_search_value,
                  process_date_from: startResult,
                  process_date_to: endResult,
                  display_id:'SID1023',
                  contract_kbn:mediaDropdownValue,
                  theme_id: this.select_theme_id,
                  theme_browsing: this.theme_browsing
                }
              }
              else
              {
                searchDetails = {
                  contract_id:this.contractId,
                  user_id:this.userId,
                  search_title:this.select_search_value,
                  process_date_from: startResult,
                  process_date_to: endResult,
                  display_id:'SID1023',
                  contract_kbn:mediaDropdownValue,
                  theme_browsing: this.theme_browsing
                }
              }
            }
            else if(this.forminline.firstInput != '')
            {
              if(this.forminline.secondInput != '')
              {
                if(this.select_theme_value != '')
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    key_word: this.forminline.firstInput,
                    media_name: this.forminline.secondInput,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1023',
                    contract_kbn:mediaDropdownValue,
                    theme_id: this.select_theme_id,
                    theme_browsing: this.theme_browsing
                  }
                }
                else
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    key_word: this.forminline.firstInput,
                    media_name: this.forminline.secondInput,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1023',
                    contract_kbn:mediaDropdownValue,
                    theme_browsing: this.theme_browsing
                  }
                }
              }
              else
              {
                if(this.select_theme_value != '')
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    key_word: this.forminline.firstInput,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1023',
                    contract_kbn:mediaDropdownValue,
                    theme_id: this.select_theme_id,
                    theme_browsing: this.theme_browsing
                  }
                }
                else
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    key_word: this.forminline.firstInput,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1023',
                    contract_kbn:mediaDropdownValue,
                    theme_browsing: this.theme_browsing
                  }
                }
              }
            }
            else
            {
              if(this.forminline.secondInput != '')
              {
                if(this.select_theme_value != '')
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    media_name: this.forminline.secondInput,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1023',
                    contract_kbn:mediaDropdownValue,
                    theme_id: this.select_theme_id,
                    theme_browsing: this.theme_browsing
                  }
                }
                else
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    media_name: this.forminline.secondInput,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1023',
                    contract_kbn:mediaDropdownValue,
                    theme_browsing: this.theme_browsing
                  }
                }
              }
              else
              {
                if(this.select_theme_value != '')
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1023',
                    contract_kbn:mediaDropdownValue,
                    theme_id: this.select_theme_id,
                    theme_browsing: this.theme_browsing
                  }
                }
                else
                {
                  searchDetails = {
                    contract_id:this.contractId,
                    user_id:this.userId,
                    process_date_from: startResult,
                    process_date_to: endResult,
                    display_id:'SID1023',
                    contract_kbn:mediaDropdownValue,
                    theme_browsing: this.theme_browsing
                  }
                }
              }
            }
            this.loadTableComment = searchDetails
            Vue.prototype.$session.set('InputParameterFor0006',searchDetails);
            Vue.prototype.$session.set('CurrentAID',"0071");
            //Api call for load the table data
            this.loading = true;
            this.$store.dispatch('communication1023/getTableData', searchDetails).then(() =>{
              this.loading = false;
              var company_configuration_info_mc=this.getCompanyConfigurationInfo;
                  for(var j=0;j<company_configuration_info_mc.length;j++){
                    if(company_configuration_info_mc[j].configuration_key == "IS_OPEN_ARTICLE" ){
                      if(company_configuration_info_mc[j].configuration_value == "true" ){
                        this.releaseFlag= true;
                      }
                    }
                  }
              if(this.mediavalue == "WEB"){//if media value is Web
                this.isShowing_table2= true;
                this.isShowing_table5= false;
                this.isShowing_table1= false;

                this.tableflag=1;

              }else if(this.mediavalue == "雑誌"){//if media value is Magazine
                this.isShowing_table5= true;
                this.isShowing_table1= false;
                this.isShowing_table2= false;
                this.tableflag=0;

              }else{//if media value is News
                this.isShowing_table1= true;
                this.isShowing_table2= false;
                this.isShowing_table5= false;

              }
              // 2024/05/14  #13819  START
              var status = this.getStatus;
              var msgdetail = this.getErrorMessage;
              if(status == "1")
              {
                this.$alert(msgdetail,"確認", {  confirmButtonText: 'OK',dangerouslyUseHTMLString:true })
              }
              // 2024/05/14  #13819  END
            })
       this.$LogMethodOut("1023","ShowTable");
    },
    //Method for redirecting to SID0004 page
    pdfDisplay(index,rows){
      var pdfValues = {
        pdf_flag:1,
        article_info:[
            {
              article_id: rows[index].article_id,
              data_section: rows[index].data_section
            }
          ],
          user_id:this.userId,
          contract_code:this.contractId.toString(),
          theme_browsing:this.theme_browsing,
          display_id:"SID1024"
      }
      this.$store.dispatch('communication0004/getPdfDisplay', pdfValues);


    },
    //Method for redirecting to SID0008 page
    sendToTextDisplay(index,rows){
        if(rows[index].data_section == 1){
          var articleDetails = {
            articleId: rows[index].article_id,
            data_section: rows[index].data_section,
            printOption: true,
            is_mail:false,
            display_id:"SID1024"

          };
          let routeData = this.$router.resolve({name: '0008', query: articleDetails}); 
          window.open(routeData.href, '_blank');
        }else{
          var articleDetailsSC = {
            articleId: rows[index].article_id
          };
           let routeData = this.$router.resolve({name: '0007', query: articleDetailsSC}); 
           window.open(routeData.href, '_blank');
        }
          
    },
    //Method for redirecting to SID0006 and SID0007 page
    sendToCSVDisplay(index, rows){
      //if data_section value is 1, redirect to SID0006 page
      if(rows[index].data_section == 1){
            let routeData = this.$router.resolve({name: '0006'}); 
            window.open(routeData.href, '_blank');
          }else{//if data_section value is 2, redirect to SID0007 page
            let routeData = this.$router.resolve({name: '0007'}); 
            window.open(routeData.href, '_blank');
          }
    }

},

mounted() {
  this.mc_pdf_view_flag = this.getMC_Pdf_View_Flag
  this.mc_pdf_print_flag = this.getMC_Pdf_Print_Flag
  this.mc_text_view_flag = this.getMC_Text_View_Flag
  this.mc_text_print_flag = this.getMC_Text_Print_Flag

  this.sc_pdf_view_flag = this.getSC_Pdf_View_Flag
  this.sc_pdf_print_flag = this.getSC_Pdf_Print_Flag
  this.sc_text_view_flag = this.getSC_Text_View_Flag
  this.sc_text_print_flag = this.getSC_Text_Print_Flag


  //get the session id value from session
  this.session_id = Vue.prototype.$session.get('session-id');

  //get the user id value from session
  this.userId = this.getUserId

  //get the contract_id value from session
  this.contractId = this.getContractId;

  //get the contract_code value from session
  this.contractCode = this.getContractCode;

  //get the theme_browsing value from session
  this.theme_browsing = this.getThemeBrowsing;

  this.user_group_name = this.getUserGroupName

  var credentials = {
    contract_id:this.contractId,
    user_id:this.userId
  };

  //Api call for get search dropdown data
  this.$store.dispatch('communication1023/getArticleSearch', credentials);
 
  var themeDetails = {
      contract_id:this.contractId,
      theme_browsing:this.theme_browsing,
      user_id:this.userId,
      display_id:"SID1023"
      
  };
  //Api call for get theme data
  this.$store.dispatch('communication1023/getTheme', themeDetails);
  
  // Media Dropdown based on Service linkage info from login
  /*** Change by SJ for backlog Id: 1627 */
  var service_linkage = this.getServiceLinkageInfo;
    var dataSection_arr=[];
        if(service_linkage != null)
        {
            for(var k=0; k<service_linkage.length; k++)
            {
                var data_section_linkage = service_linkage[k].data_section;
                dataSection_arr.push(data_section_linkage);
            }

        }
    var mediaoptions = [];
    var newspaperflag = 0;
    var magazineflag = 0;
    var webflag = 0; 
    for(var kd=0; kd<service_linkage.length; kd++)
    {
        var data_section_linkages = service_linkage[kd].data_section;
        if(data_section_linkages == 1 || data_section_linkages == 2)
        {
            newspaperflag = 1;
            /*
            * Backlog issue related fix
            * Author: BM
            * Backlog Id: BT08460_EXTERNAL-1627
            * The default display of the "Media" item is blank on the article maintenance screen.(using service linkage)
            */
            this.forminline.medium="新聞";
            this.mediavalue = "新聞";
        }
        else if(data_section_linkages == 5)
        {
            magazineflag = 1;
            if(newspaperflag ==1){
              //console.log("news exists")
            }else{
              this.forminline.medium="雑誌";
              this.mediavalue = "雑誌";
            }     
        }
         else if(data_section_linkages == 3)
        {
            webflag = 1;
             /*
            * Backlog issue related fix
            * Author: BM
            * Backlog Id: BT08460_EXTERNAL-1627
            * The default display of the "Media" item is blank on the article maintenance screen.(using service linkage)
            */
            if(newspaperflag == 1){
              //console.log("news exists")
            }else{
              this.forminline.medium="WEB";
              this.mediavalue = "WEB";
            }
             
        }
    }

    if(newspaperflag == 1)
    {
        var mediaoptions_news = {};
        mediaoptions_news.value = "新聞";
        mediaoptions_news.label = "新聞";
        mediaoptions.push(mediaoptions_news);
    }

    if(magazineflag == 1)
    {
        var mediaoptions_magazine = {};
        mediaoptions_magazine.value = "雑誌";
        mediaoptions_magazine.label = "雑誌";
        mediaoptions.push(mediaoptions_magazine);
    }
    
    if(webflag == 1)
    {
        var mediaoptions_web = {};
        mediaoptions_web.value = "WEB";
        mediaoptions_web.label = "WEB";
        mediaoptions.push(mediaoptions_web);
    }
    this.$store.commit('situation1023/setmediumoptions', mediaoptions, { root: true });


  //get the message_info value from session
    var message_info = this.getMessageInfo

    for(var u=0;u<message_info.length;u++)
    {
      if(message_info[u].message_key == "demandConfirmPdfMessage")
      {
        this.pdf_confirm_message_flag = message_info[u].configuration_value
      }
      else if(message_info[u].message_key == "demandConfirmTextMessage")
      {
        this.text_confirm_message_flag = message_info[u].configuration_value
      }
      else if(message_info[u].message_key == "demandConfirmPrintMessage")
      {
        this.print_confirm_message_flag = message_info[u].configuration_value
      }
      else
      {
        //no action needed
      }
    }

},
beforeCreate(){
  //Common.Session.CheckSessionExists_IfExpired_GoToLogout();
},
created(){
  
      //For the screen Title
     document.title = "記事メンテナンス画面";
  
}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "1023.css";
</style>